import { render, staticRenderFns } from "./HomeApp.vue?vue&type=template&id=6ed3c3d9"
import script from "./HomeApp.vue?vue&type=script&lang=js"
export * from "./HomeApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed3c3d9')) {
      api.createRecord('6ed3c3d9', component.options)
    } else {
      api.reload('6ed3c3d9', component.options)
    }
    module.hot.accept("./HomeApp.vue?vue&type=template&id=6ed3c3d9", function () {
      api.rerender('6ed3c3d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/HomeApp.vue"
export default component.exports